import styled from "styled-components";

export const HeaderWrapper = styled.div`
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  padding: 14px 22px;
  border-radius: 16px;
  background: #1C2634 !important;
  background-image: linear-gradient(135deg, #1C2634 0%, #243140 100%) !important;
  box-shadow: 0 6px 20px rgba(28,38,52,0.18);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    width: 300px; height: 300px;
    border-radius: 50%;
    background: rgba(80,149,64,0.10);
    top: -160px; right: -120px;
    pointer-events: none;
  }

  .dash-center-logo {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
    background: #fff;
    padding: 7px 16px;
    border-radius: 10px;
    box-shadow: 0 4px 14px rgba(0,0,0,0.18);
    transition: transform 0.2s;

    a { display: block; line-height: 0; }

    img {
      height: 32px;
      width: auto;
      display: block;
    }

    &:hover { transform: translate(-50%, calc(-50% - 2px)); }

    @media only screen and (max-width: 540px) {
      img { height: 26px; }
      padding: 5px 12px;
    }
  }

  .left {
    align-items: center;
    gap: 16px;
    margin-left: 6px;
    position: relative;
    z-index: 1;

    .badgeIcon {
      width: 42px;
      height: 42px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 10px;
      background: rgba(255,255,255,0.08);
      border: 1px solid rgba(255,255,255,0.12);
      transition: all 0.2s;
      cursor: pointer;

      &:hover {
        background: rgba(80,149,64,0.25);
        border-color: rgba(80,149,64,0.5);
      }

      img { width: 18px !important; filter: brightness(0) invert(1); }
    }
  }

  .right {
    background: rgba(255,255,255,0.10);
    border: 1px solid rgba(255,255,255,0.15);
    box-shadow: none;
    border-radius: 50px;
    align-items: center;
    align-self: center;
    gap: 10px;
    padding: 4px 18px 4px 4px;
    color: #fff;
    font-size: 14px;
    height: 46px;
    font-weight: 600;
    margin-right: 4px;
    cursor: pointer;
    transition: all 0.2s;
    position: relative;
    z-index: 1;
    backdrop-filter: blur(4px);

    &:hover {
      background: rgba(80,149,64,0.20);
      border-color: rgba(80,149,64,0.5);
    }

    .name { white-space: nowrap; }

    .icon {
      width: 38px;
      height: 38px;
      border-radius: 50%;
      background: linear-gradient(135deg, #509540, #3d7a30);
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 2px 8px rgba(80,149,64,0.4);

      .initial {
        color: #fff;
        font-size: 18px;
        font-weight: 700;
        line-height: 1;
        text-transform: uppercase;
        user-select: none;
      }
    }
  }

  @media only screen and (max-width: 500px) {
    padding: 12px 14px;
    .left { gap: 8px; .badgeIcon { width: 38px; height: 38px; } }
    .right { padding-right: 12px; font-size: 13px; height: 42px; .icon { width: 34px; height: 34px; } }
  }
`;
